export default __webpack_public_path__ + "static/media/applications-image-15.3552b376.jpg";